import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Switch } from 'antd';
import { showMap, hideMap } from '../../../../actions/map';
import { t } from '../../../../helpers/t';

const ShowMap = () => {
  const dispatch = useDispatch();
  const { mapVisible } = useSelector((state) => state.map);

  return (
    <div id="show-map-switch">
      <div className="label">
        {t('directives.listings.mapToggle.show')}
      </div>
      <Switch
        checked={mapVisible}
        onChange={(value) => {
          dispatch(
            value
              ? showMap()
              : hideMap()
          );
        }}
      />
    </div>
  );
};

export default ShowMap;
